import { render, staticRenderFns } from "./DialogPlanStrategia.vue?vue&type=template&id=53494d2e&scoped=true&"
import script from "./DialogPlanStrategia.vue?vue&type=script&lang=js&"
export * from "./DialogPlanStrategia.vue?vue&type=script&lang=js&"
import style0 from "./DialogPlanStrategia.vue?vue&type=style&index=0&id=53494d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53494d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53494d2e')) {
      api.createRecord('53494d2e', component.options)
    } else {
      api.reload('53494d2e', component.options)
    }
    module.hot.accept("./DialogPlanStrategia.vue?vue&type=template&id=53494d2e&scoped=true&", function () {
      api.rerender('53494d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogPlanStrategia.vue"
export default component.exports